import type { BaseObject, RecordMode } from './Base';

export type DeviceConfiguration = BaseObject & {
  code?: string;
  name?: string;
  functionality: number | null;
  functionalityString?: string;
  loadItemLines: number;
  deviceID: string;
  documentTypeID: string;
  documentSeriesID: string;
  defaultUserID?: string;
  companySiteID: string;
  device?: BaseObject & {
    code: string;
    name: string;
    remarks?: string | null;
    updateUser?: {
      id: string;
      userName: string;
      name: string;
    } | null;
    createUser?: {
      id: string;
      userName: string;
      name: string;
    } | null;
  };
  documentType?: {
    id: string;
    code: string;
    name: string;
  };
  documentSeries?: {
    id: string;
    code: string;
    name: string;
  };
  user?: {
    id: string;
    userName: string;
    name: string;
  };
  companySite?: {
    id: string;
    name: string;
  };
  recordMode?: RecordMode;
};

export enum eFunctionality {
  CompetitorPriceCollection = 0,
  PriceCollection = 1,
  Other = 2,
  Transactions = 3,
}
